import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import { List as IList } from 'immutable';
import Icon from 'flow/components/ui-components/Icon';
import Checkbox from 'flow/components/ui-components/Checkbox';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DragHandle = SortableHandle(function () {
  return /*#__PURE__*/_jsx(Icon, {
    iconKey: "dragHandle"
  });
});
var CheckboxListDraggable = /*#__PURE__*/function (_React$PureComponent) {
  function CheckboxListDraggable(props) {
    var _this;
    _classCallCheck(this, CheckboxListDraggable);
    _this = _callSuper(this, CheckboxListDraggable, [props]);
    _defineProperty(_this, "renderCheckboxListItem", function (item, DragHandle, disabled) {
      return /*#__PURE__*/_jsx("li", {
        className: "relative z-30 list-none rounded-sm p-1 hover:bg-gray-100",
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex w-full items-center justify-between",
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex items-center",
            children: /*#__PURE__*/_jsx(Checkbox, {
              label: item.get('value'),
              checked: !!item.get('selected'),
              disabled: disabled,
              onChange: function onChange(event, value) {
                return _this.onCheckboxChange(event, value, item.get('key'));
              }
            }, item.get('key'))
          }), /*#__PURE__*/_jsx("div", {
            className: "cursor-move rounded-sm p-1 hover:bg-gray-200",
            children: /*#__PURE__*/_jsx(DragHandle, {
              className: "rounded-sm text-gray-600"
            })
          })]
        })
      }, item.get('key'));
    });
    _defineProperty(_this, "onCheckboxChange", function (_event, value, key) {
      var onItemsUpdate = _this.props.onItemsUpdate;
      var itemsAllSorted = _this.state.itemsAllSorted;
      var index = itemsAllSorted.findIndex(function (item) {
        return item.get('key') === key;
      });
      var item = itemsAllSorted.get(index).set('selected', value);
      var itemsUpdated = itemsAllSorted.set(index, item);
      _this.setState({
        itemsAllSorted: itemsUpdated
      });
      onItemsUpdate(itemsUpdated);
    });
    _defineProperty(_this, "onSortEnd", function (_ref) {
      var oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex;
      var onItemsUpdate = _this.props.onItemsUpdate;
      var itemsAllSorted = _this.state.itemsAllSorted;
      var itemToMove = itemsAllSorted.get(oldIndex);
      var listNew = itemsAllSorted["delete"](oldIndex).insert(newIndex, itemToMove);
      _this.setState({
        itemsAllSorted: listNew
      });
      onItemsUpdate(listNew);
    });
    _this.state = {
      itemsAllSorted: props.items
    };
    return _this;
  }
  _inherits(CheckboxListDraggable, _React$PureComponent);
  return _createClass(CheckboxListDraggable, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var maxSelectionAmount = this.props.maxSelectionAmount;
      var itemsAllSorted = this.state.itemsAllSorted;
      var itemsSelected = itemsAllSorted.filter(function (item) {
        return item.get('selected');
      });
      var maximumItemsSelected = itemsSelected && maxSelectionAmount && itemsSelected.size >= maxSelectionAmount;
      var SortableItem = SortableElement(function (_ref2) {
        var value = _ref2.value;
        var disabled = maximumItemsSelected && !value.get('selected') || value.get('disabled');
        return _this2.renderCheckboxListItem(value, DragHandle, disabled);
      });
      var SortableList = SortableContainer(function (_ref3) {
        var items = _ref3.items;
        return /*#__PURE__*/_jsx("ul", {
          children: items.map(function (value, index) {
            return /*#__PURE__*/_jsx(SortableItem, {
              index: index,
              value: value
            }, "item-".concat(index));
          })
        });
      });
      return /*#__PURE__*/_jsx(SortableList, {
        items: itemsAllSorted,
        onSortEnd: this.onSortEnd,
        useDragHandle: true
      });
    }
  }]);
}(React.PureComponent);
_defineProperty(CheckboxListDraggable, "propTypes", {
  items: PropTypes.instanceOf(IList).isRequired,
  onItemsUpdate: PropTypes.func.isRequired,
  maxSelectionAmount: PropTypes.number
});
export default CheckboxListDraggable;